import React from "react";

const PULSE_ANIMATION = "elpPulse 1.5s ease-in-out infinite";

const block = (width, height, extra = {}) => ({
  width,
  height,
  backgroundColor: "#E5E7EB",
  borderRadius: 4,
  animation: PULSE_ANIMATION,
  ...extra,
});

const lightBlock = (width, height, extra = {}) => ({
  ...block(width, height, extra),
  backgroundColor: "#F3F4F6",
});

const SkeletonCard = () => (
  <div
    style={{
      backgroundColor: "white",
      borderRadius: 12,
      border: "1px solid #E5E7EB",
      overflow: "hidden",
      boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)",
      display: "flex",
      flexDirection: "column",
    }}
  >
    <div
      style={{
        backgroundColor: "#E5E7EB",
        padding: 16,
        height: 64,
        animation: PULSE_ANIMATION,
      }}
    />

    <div style={{ padding: 16, display: "flex", flexDirection: "column", flex: 1 }}>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 6 }}>
        <div style={block("60%", 18)} />
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 12 }}>
        <div style={lightBlock("40%", 14)} />
      </div>

      <div style={{ borderTop: "1px solid #E5E7EB", marginBottom: 12 }} />

      <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 12 }}>
        {[80, 90, 70, 85, 75, 65].map((w, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={block(16, 16, { borderRadius: "50%" })} />
            <div style={lightBlock(`${w}%`, 12)} />
          </div>
        ))}
      </div>

      <div style={{ borderTop: "1px solid #E5E7EB", marginBottom: 12 }} />

      <div style={{ marginBottom: 8 }}>
        <div style={block("45%", 12)} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {[80, 90, 60, 70].map((w, i) => (
          <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
            <div style={block(14, 14, { borderRadius: 3, marginTop: 2 })} />
            <div style={lightBlock(`${w}%`, 11)} />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default function BusActivityCardSkeleton({ count = 8 }) {
  return (
    <>
      <style>{`
        @keyframes elpPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: 20,
        }}
      >
        {Array.from({ length: count }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    </>
  );
}
